import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'components/base';
import queryString from 'utils/queryString';
import Icon, { ICON_TYPE } from 'components/icon';
import classNames from 'classnames';
import sleep from 'utils/sleep';

import SETTINGS from '../settings';

export const prepareAncestryAuthUrl = (redirectUrl = '/') => {
  let url;
  if (redirectUrl != null && redirectUrl !== '/') {
    if (redirectUrl === 'referer') {
      url = [window?.location?.pathname ?? '/', window?.location?.search ?? ''].join('');
    } else {
      url = redirectUrl;
    }
  }

  const query = {
    response_type: 'code',
    client_id: SETTINGS.ANCESTRY_CLIENT_ID,
    redirect_uri: SETTINGS.ANCESTRY_REDIRECT_URI,
    scope:
      'openid btas.trees treeservice.service contextapp.service records.service openid.fullprofile user.rights',
  };

  if (url) {
    query.state = JSON.stringify({ url });
  }

  return queryString.stringifyUrl('https://www.ancestry.com/sso/oidc/authorize', query);
};

const SignInWithAncestry = props => {
  const handleOnSignInClick = async () => {
    // Fire tracking synchronously before navigation so async transports
    // (PostHog sendBeacon/keepalive) are enqueued while the page is alive.
    if (typeof props.onBeforeRedirect === 'function') {
      props.onBeforeRedirect();
    }

    window.location = prepareAncestryAuthUrl(props.redirectUrl);

    await sleep(15000);
  };

  const fullWidth = (props.className ?? '').includes('w-100');

  return (
    <div className={props.className}>
      <Button
        type="ancestry"
        onClick={handleOnSignInClick}
        className={classNames({
          'position-relative': fullWidth,
          'w-100': fullWidth,
          'mb-1': props.children,
        })}
      >
        <Icon
          type={ICON_TYPE.ANCESTRY}
          className={classNames({
            'position-absolute': fullWidth,
            'mr-1': !fullWidth,
          })}
          size={20}
          style={{ left: fullWidth ? 14 : undefined }}
        />
        Login with Ancestry
      </Button>
      {props.children}
    </div>
  );
};

SignInWithAncestry.propTypes = {
  className: PropTypes.string,
  // redirectUrl should be custom redirect url or enum referer
  redirectUrl: PropTypes.string,
  children: PropTypes.node,
  // Called right before window.location is set — use for analytics that must
  // fire before the browser starts unloading the page.
  onBeforeRedirect: PropTypes.func,
};

SignInWithAncestry.defaultProps = {
  redirectUrl: '/',
};

export const SignInWithAncestryToggler = ({ toggler, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card className={classNames(isOpen ? 'border-black' : 'border-white', className)}>
      <Button
        type={isOpen ? 'default' : 'ancestry'}
        className="w-100"
        size="sm"
        onClick={() => {
          setIsOpen(val => !val);
        }}
      >
        <Icon
          type={ICON_TYPE.ANCESTRY}
          className="position-absolute"
          size={22}
          style={{ left: 14 }}
        />
        <span>Continue with Ancestry</span>
      </Button>
      <Card.Body className={isOpen ? 'd-block' : 'd-none'}>{children}</Card.Body>
    </Card>
  );
};

export default SignInWithAncestry;
